function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.30005 23.1001H20.3001",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.30005 9.1001V23.9001C6.30005 25.0047 7.19548 25.9001 8.30005 25.9001H18.3001C19.4046 25.9001 20.3001 25.0047 20.3001 23.9001V9.1001",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3 11.8999H23.5C24.0523 11.8999 24.5 12.3476 24.5 12.8999V19.2999C24.5 19.8522 24.0523 20.2999 23.5 20.2999H20.3",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.1001 14L9.1001 20.3",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3 14L13.3 20.3",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 12.6001L17.5 20.3001",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.8999 9.1001H8.99221C9.43828 9.1001 9.7999 9.46171 9.7999 9.90779V10.8501C9.7999 11.8166 10.5834 12.6001 11.5499 12.6001V12.6001C12.5164 12.6001 13.2999 11.8166 13.2999 10.8501V9.90779C13.2999 9.46171 13.6615 9.1001 14.1076 9.1001H21.6999",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6999 9.1C23.2463 9.1 24.4999 7.8464 24.4999 6.3C24.4999 4.7536 23.2463 3.5 21.6999 3.5C20.1535 3.5 18.8999 4.7536 18.8999 6.3",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M4.90005 9.10029C4.12685 9.10029 3.50005 8.47349 3.50005 7.70029C3.50005 6.92709 4.12685 6.30029 4.90005 6.30029C5.67325 6.30029 6.30005 6.92709 6.30005 7.70029V6.30029",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7 6.3001C14.7 3.9805 12.8196 2.1001 10.5 2.1001C8.18045 2.1001 6.30005 3.9805 6.30005 6.3001",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9 6.30019C18.9 5.1404 17.9597 4.2002 16.8 4.2002C15.6402 4.2002 14.7 5.1404 14.7 6.30019",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var SvgBeer = function SvgBeer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beer.5d3a0512.svg";
export { ForwardRef as ReactComponent };